import axios from 'axios';
import {typesSojProd} from '../svtypes/sojProd'
import { PRICEGATEWAY_SOJOURN, PRICEGATEWAY_AMD,SV_SOJ_ORCMOCK_ADDRESS, SV_SOJ_SVDJMOCK_ADDRESS } from '../../constants';

const _ = require('lodash')

function lowercaseKeys(obj) {
    return Object.keys(obj).reduce((accumulator, key) => {
      accumulator[key.toLowerCase()] = obj[key];
      return accumulator;
    }, {});
  }


  /*svjmak19 sya=start*/

export function sojAndImagesSojourn(sojPostRqFromPage, sv_esquery_data){
    console.log('sv**MAY3Y2025 esqueryText*********', sv_esquery_data)
                       
    return dispatch => {
        dispatch(getEsSearchBegin())
       
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuilaCanQueryFinal`
        
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/shpoint/sojournsttr`
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/shpoint/sojourndol`
    //getResAsyncWorkingSvCanQueryTermsSojDyna
    ///sojournpoint/svsojournCanQueryFinalDyna
    const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/svsojournCanQueryFinalDyna`
       //mock workin may12
       //http://localhost:8086/shpoint/sojourndol
       /*
         const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/svsojournCanQueryFinal`
      
      

        */
         let sojPostRq= {
            "svfields": [
                "sojourn_name",
                "code",
                "address",
                "sojourn_city",
                "countryCode",
                "stateCode",
                "postalCode",
                "destinationCode"
            ],
            "dates": {
                "STARTDATE_ITN_TZAWARE_EST": "2025-08-19",
                "ENDDATE_ITN_TZAWARE_EST": "2025-08-25",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata",
                "OP": "range"
            },
            "facets": {
                "PMSRoomCode": "APT"
            },
            "useCity": true,
            "dst": "BEVERLY HILLS",
            "esqueryChilds": "m0",
            "esqueryInfants": "i0",
            "esqueryAdults": "t1",
            "esqueryCabin": "ECONOMY",
            "esqueryTripType": "roundtrip",
            "svpageSize": 5,
            "codeKeys": [
                   
                ],
            "destinationCode": "MCO",
            "esqueryRooms": "r1"
        }
          let sojPostRqDyna = {
            "query": {
                "multi_match": {
                    "fields": [
                        "STATE",  "ADDRESS_LINE1", "COUNTRY_NAME", "SOJOURN_NAME"
                    ],
                    "query": "WorldMark Long Beach",
                    "operator": "or",
                    "fuzziness": "AUTO"
                }
            },
            "post_filter": {
                "range" : {
                    "STARTDATE": {
                        "gte" : "2023-10-24",
                        "lt" :  "2023-11-27",
                        "time_zone": "+01:00"
                    }
                }
              }
        }
        const HBD_URL = 'http://photos.hotelbeds.com/giata/'
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
       console.log('sv****8')
        if(sojPostRqFromPage){
            sojPostRq = sojPostRqFromPage
        }
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers})
        ])
        .then(
            axios.spread((rFobAx,r2)=>{
                let rFob = rFobAx.data
                let r = {data:{}}
                r.data = rFob.svo
                let p = {data:{}}
                p.data  = rFob.dbo
                let prices = []
                let prices_idx = []
                let a_price = null;
                let prices_map = {}
               
                if(p.data.length>0){
                    prices_idx = p.data
                }
                let aird = null
                let airc = null
                prices_idx.forEach(p_rec => {
                    let myh = p_rec['hotel']
                    //change this code as SPACEKEY is number
                    /*
                        let mys = p_rec['SPACEKEY']
                        let p =mys.indexOf('@')
                        let mytail = mys.substr(p, mys.length) 
                        
                        let myhead = myh['code']
                        let ckey =myhead + mytail
                         p_rec['SPACEKEY'] = ckey
                        p_rec['ABODE_SPACE_ID'] = myhead
                        p_rec['SOJOURN_NAME']= myh['sojourn_name']
                        if(p_rec['SPACE_KEY'] ){
                            p_rec['SPACE_KEY'] = ckey
                        }
                    */
                       
                        p_rec['ranking'] = myh['ranking'] ?myh['ranking'] : "NA"
                        p_rec['web'] = myh['web'] ?myh['web'] : "http://svrenaissance.org/svceo"

                        if(p_rec['terminals'] &&  p_rec['terminals'][0]){
                            let ta =  p_rec['terminals'][0]
                            aird = ta["distance"]
                            airc = ta["terminalCode"]
                            p_rec['airportDistance'] =  `${aird} miles from  ${airc} airport`
                        }
                    let p_item = {}
                    let p_lc = {}
                    p_item = p_rec
                    p_lc =lowercaseKeys(p_item)
                    prices.push(p_lc)
                   
                });
                prices.forEach(p => {
                    let k =p.spacekey
                    prices_map[k] = p
                });
                console.log('sv**SPET9 MONDAY **************** Prices_map START')
                console.log(prices_map)
                console.log('sv**SPET9 MONDAY **************** Prices_map END')
                if(r.data.length>0){
                    const ar = r.data
                    const comData = { my_data: []}
                    let item , ob, upperOb
                    if( r2.data && r2.data.images[0]){
                        comData.my_images = r2.data.images[0]
                    }
                    //get path and concat them wil base url
                  
                    ar.forEach(a_rec => {
                        let myh = a_rec['hotel']
                        /*
                        let mys = a_rec['SPACEKEY']
                        let p =mys.indexOf('@')
                        let mytail = mys.substr(p, mys.length) 
                        
                        let myhead = myh['code']
                        let ckey =myhead + mytail
                        a_rec['SPACEKEY'] = ckey
                        if(a_rec['SPACE_KEY'] ){
                            a_rec['SPACE_KEY'] = ckey
                            a_rec['SOJOURNCODE'] = ckey
                            a_rec['SPACE_INV_ID']= ckey
                            a_rec['ABODE_SPACE_ID'] = ckey
                            a_rec['ABODESPACEID'] = ckey
                            
                        }
                        */
                        a_rec['ranking'] = myh['ranking'] ?myh['ranking'] : "NA"
                        a_rec['web'] = myh['web'] ?myh['web'] : "NA"

                        a_rec['SOJOURN_NAME']= myh['sojourn_name']
                        a_rec["COUNTRY_NAME"]= myh['countryCode']
                        let address_s = a_rec["ADDRESS_LINE1"]
                        const {address} = myh
                        let anum_s = address.number ?address.number : ''
                       
                        if(myh['address']){
                            address_s =  anum_s + " "+address.street
                        }
                        a_rec["ADDRESS_LINE1"] = address_s
                        item = {}
                        let hbd_images  = a_rec.hotel.images
                        let imgs = []
                        //hbd_images  = hbd_images? hbd_images : r2.data.images
                        if(hbd_images && (hbd_images.length > 0) ){
                            hbd_images.forEach(im =>{
                                let sim =  HBD_URL +  im.path 
                                imgs.push(sim)
                               })
                        }else{
                            imgs = r2.data.images
                        }
                       
                        if(imgs.length > 0){
                            comData.my_images = imgs
                        }

                        upperOb = a_rec
                        ob =lowercaseKeys(upperOb)
                        //svjun9
                        let k_sv = ob['spacekey']
                        a_price = prices_map[k_sv]
                        let assets = a_price['assets']
                        const aroom = assets[0]
                        const {rates} = aroom
                        const arate = rates[0]
                        let {taxes} = arate
                        a_rec['product_cost_amount'] = arate['net']

                        //svjun9 end

                        let HB_REVIEWS_HW = [
                            {
                                "rate": 4,
                                "reviewCount": 15,
                                "type": "HOTELBEDS"
                            }
                        ]
                        let reviews_ob = a_price["reviews"] ?a_price["reviews"] : HB_REVIEWS_HW
                        
                        let review_ob = reviews_ob[0]
                       //num_reviews
                        let rating = (review_ob['rate']? review_ob['rate'] : 0 )
                        let reviewCount = (review_ob[ "reviewCount"]? review_ob[ "reviewCount"] : 0 )
                        ob['num_reviews'] = reviewCount
                        //let rating = (ob['svr_vep_rating']? ob['svr_vep_rating'] : 0 )
                        let sv_rating = 'Excellent'
                       if(rating == 0){
                        sv_rating = 'Excellent'
    
                       }else if(rating == 1){
    
                        sv_rating = 'Poor'
                    }else if(rating == 2){
                        sv_rating = 'Fair'
                    }else if(rating == 3){
    
                        sv_rating = 'Recommend'
                    }else if(rating == 4){
                        sv_rating = 'Favorite'
                    }else if(rating == 5){
                        sv_rating = 'Excellent'
                    }else {
    
                        sv_rating = 'Excellent'
                       }
                    ob['sv_rating'] = sv_rating
                    ob['sv_availability_of_rooms'] = 8
                    ob['imgs'] = imgs
                    
                    if(a_price){

                        ob = _.merge(ob, a_price)
                    }
                         
                       /*
                        item['sojourncode']= ob['sojourncode']
                        item['vernacularcode']= ob['vernacularcode']
                        item['sojourn_name']= ob['sojourn_name']
                         comData.my_data.push(item)
                        */
                       
    
                        comData.my_data.push(ob)
                        console.log('sv**OCT16 esqueryText partof sv_esquery_data*********', sv_esquery_data)
                        comData.sv_esquery_data =  sv_esquery_data  
                    });
                   
                   
                    dispatch(getEsSearchMultiplceCallsSuccess(comData))
                }
                else {
                    const comData = { items: []}
                    comData.sv_esquery_data = {
                        my_esqueryText: "mexco",
                        STARTDATE:"2025-10-24",
                        ENDDATE: "2025-11-27" , 
                        time_zone: "+01:00"
                
                      }
                      if(sv_esquery_data){
                        comData.sv_esquery_data = sv_esquery_data
                      }
                      /*sjjun19 start
                       dispatch(getEsSearchSuccess(comData))

                      */
                    dispatch(getEsSearchServerError(comData))

                     /*sjjun19 end  getEsSearchError*/
                }
                  
                   
                }
            )
        ).catch(
            e=>{dispatch(getEsSearchError(e))}
           
        )
    }
}

/*sjjun12 start */
export function sojAndImagesSojournMore(sojPostRqFromPage,sv_esquery_data){
// my_scr_id:"FGluY2x1ZGVfY29udGV4dF91dWlkDXF1ZXJ5QW5kRmV0Y2gBFkpsWjEtSjJpU0VlUnFWRFRUcDZrMlEAAAAAAAATQRZqU0xtQ3VBQ1NPZWNXbGI5NEx6TVdR",
   
    console.log('sv**MAY3Y2025 sojPostRqFromPage*********', sojPostRqFromPage)
      // my_scr_id = my_scr_id ? my_scr_id:   "FGluY2x1ZGVfY29udGV4dF91dWlkDXF1ZXJ5QW5kRmV0Y2gBFkpsWjEtSjJpU0VlUnFWRFRUcDZrMlEAAAAAAAATQRZqU0xtQ3VBQ1NPZWNXbGI5NEx6TVdR"            
    return dispatch => {
        dispatch(getEsSearchBegin())
       
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuilaCanQueryFinal`
        
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/shpoint/sojournsttr`
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/shpoint/sojourndol`
    //getResAsyncWorkingSvCanQueryTermsSojDyna
    ///sojournpoint/svsojournCanQueryFinalDyna
    const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/svsojournCanQueryFinalDynaPaginateMore`
       //mock workin may12
       //http://localhost:8086/shpoint/sojourndol
       /*
         const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/svsojournCanQueryFinal`
      
      

        */
         let sojPostRq= {
            "svfields": [
                "images",
                "sojourn_name",
                "address",
               
                "code",
                "sojournGeocode",
                "categoryCode",
                "categoryGroupCode",
                "accommodationTypeCode",
        
                "sojourn_city",
                "countryCode",
                "stateCode",
                "postalCode",
                 "countryCode",
                 "ranking",
                 "web",
                 "terminals",
                "destinationCode"
            ],
            "dates": {
                "STARTDATE_ITN_TZAWARE_EST": "2028-08-01",
                "ENDDATE_ITN_TZAWARE_EST": "2028-08-08",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata",
                "OP": "range"
            },
        
            "facets": {
                "accommodationTypeCode": "H"
            },
            "useCity": false,
            "dst":  "LAX",
        
            "esqueryChilds": "m0",
            "esqueryInfants": "i0",
            "esqueryAdults": "t1",
            "esqueryCabin": "ECONOMY",
            "esqueryTripType": "roundtrip",
            "svpageSize": 5,
            "codeKeys": [
                   
                ],
            "destinationCode":  "LAX",
            "esqueryRooms": "r1",

            "pagenumber":1,
             "my_scr_id":"FGluY2x1ZGVfY29udGV4dF91dWlkDXF1ZXJ5QW5kRmV0Y2gBFkpsWjEtSjJpU0VlUnFWRFRUcDZrMlEAAAAAAAATQRZqU0xtQ3VBQ1NPZWNXbGI5NEx6TVdR"
        }
        
        const HBD_URL = 'http://photos.hotelbeds.com/giata/'
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
       console.log('sv****8')
        if(sojPostRqFromPage){
            sojPostRq = sojPostRqFromPage
        }
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers})
        ])
        .then(
            axios.spread((rFobAx,r2)=>{
                let rFob = rFobAx.data
                let r = {data:{}}
                if(rFob.svo){
                     console.log('s***  JUN13 got MORE DATA')
                }else{
                    console.log('s***  JUN13 got EMPTY MORE DATA stop scrolling')
                    let comDataEmpty = { items: []}
                   
                   return  dispatch(getEsEmptySuccess(comDataEmpty)) 
                }
                r.data = rFob.svo
                let p = {data:{}}
                p.data  = rFob.dbo
                let prices = []
                let prices_idx = []
                let a_price = null;
                let prices_map = {}
               
                if(p.data.length>0){
                    prices_idx = p.data
                }
                let aird = null
                let airc = null
                prices_idx.forEach(p_rec => {
                    let myh = p_rec['hotel']
                    //change this code as SPACEKEY is number
                    /*
                        let mys = p_rec['SPACEKEY']
                        let p =mys.indexOf('@')
                        let mytail = mys.substr(p, mys.length) 
                        
                        let myhead = myh['code']
                        let ckey =myhead + mytail
                         p_rec['SPACEKEY'] = ckey
                        p_rec['ABODE_SPACE_ID'] = myhead
                        p_rec['SOJOURN_NAME']= myh['sojourn_name']
                        if(p_rec['SPACE_KEY'] ){
                            p_rec['SPACE_KEY'] = ckey
                        }
                    */
                       
                        p_rec['ranking'] = myh['ranking'] ?myh['ranking'] : "NA"
                        p_rec['web'] = myh['web'] ?myh['web'] : "http://svrenaissance.org/svceo"

                        if(p_rec['terminals'] &&  p_rec['terminals'][0]){
                            let ta =  p_rec['terminals'][0]
                            aird = ta["distance"]
                            airc = ta["terminalCode"]
                            p_rec['airportDistance'] =  `${aird} miles from  ${airc} airport`
                        }
                    let p_item = {}
                    let p_lc = {}
                    p_item = p_rec
                    p_lc =lowercaseKeys(p_item)
                    prices.push(p_lc)
                   
                });
                prices.forEach(p => {
                    let k =p.spacekey
                    prices_map[k] = p
                });
                console.log('sv**JUN13 MONDAY **************** Prices_map START')
                console.log(prices_map)
                console.log(r.data)
                console.log('sv**JUN1 MONDAY **************** Prices_map END')
                if( (r.data)  && (r.data.length > 0) ){
                    
                    const ar = r.data
                    const comData = { my_data: []}
                    let item , ob, upperOb
                    if( r2.data && r2.data.images[0]){
                        comData.my_images = r2.data.images[0]
                    }
                    //get path and concat them wil base url
                  
                    ar.forEach(a_rec => {
                        let myh = a_rec['hotel']
                        /*
                        let mys = a_rec['SPACEKEY']
                        let p =mys.indexOf('@')
                        let mytail = mys.substr(p, mys.length) 
                        
                        let myhead = myh['code']
                        let ckey =myhead + mytail
                        a_rec['SPACEKEY'] = ckey
                        if(a_rec['SPACE_KEY'] ){
                            a_rec['SPACE_KEY'] = ckey
                            a_rec['SOJOURNCODE'] = ckey
                            a_rec['SPACE_INV_ID']= ckey
                            a_rec['ABODE_SPACE_ID'] = ckey
                            a_rec['ABODESPACEID'] = ckey
                            
                        }
                        */
                        a_rec['ranking'] = myh['ranking'] ?myh['ranking'] : "NA"
                        a_rec['web'] = myh['web'] ?myh['web'] : "NA"

                        a_rec['SOJOURN_NAME']= myh['sojourn_name']
                        a_rec["COUNTRY_NAME"]= myh['countryCode']
                        let address_s = a_rec["ADDRESS_LINE1"]
                        const {address} = myh
                        let anum_s = address.number ?address.number : ''
                       
                        if(myh['address']){
                            address_s =  anum_s + " "+address.street
                        }
                        a_rec["ADDRESS_LINE1"] = address_s
                        item = {}
                        let hbd_images  = a_rec.hotel.images
                        let imgs = []
                        //hbd_images  = hbd_images? hbd_images : r2.data.images
                        if(hbd_images && (hbd_images.length > 0) ){
                            hbd_images.forEach(im =>{
                                let sim =  HBD_URL +  im.path 
                                imgs.push(sim)
                               })
                        }else{
                            imgs = r2.data.images
                        }
                       
                        if(imgs.length > 0){
                            comData.my_images = imgs
                        }

                        upperOb = a_rec
                        ob =lowercaseKeys(upperOb)
                        //svjun9
                        let k_sv = ob['spacekey']
                        a_price = prices_map[k_sv]
                        let assets = a_price['assets']
                        const aroom = assets[0]
                        const {rates} = aroom
                        const arate = rates[0]
                        let {taxes} = arate
                        a_rec['product_cost_amount'] = arate['net']

                        //svjun9 end

                        let HB_REVIEWS_HW = [
                            {
                                "rate": 4,
                                "reviewCount": 15,
                                "type": "HOTELBEDS"
                            }
                        ]
                        let reviews_ob = a_price["reviews"] ?a_price["reviews"] : HB_REVIEWS_HW
                        
                        let review_ob = reviews_ob[0]
                       //num_reviews
                        let rating = (review_ob['rate']? review_ob['rate'] : 0 )
                        let reviewCount = (review_ob[ "reviewCount"]? review_ob[ "reviewCount"] : 0 )
                        ob['num_reviews'] = reviewCount
                        //let rating = (ob['svr_vep_rating']? ob['svr_vep_rating'] : 0 )
                        let sv_rating = 'Excellent'
                       if(rating == 0){
                        sv_rating = 'Excellent'
    
                       }else if(rating == 1){
    
                        sv_rating = 'Poor'
                    }else if(rating == 2){
                        sv_rating = 'Fair'
                    }else if(rating == 3){
    
                        sv_rating = 'Recommend'
                    }else if(rating == 4){
                        sv_rating = 'Favorite'
                    }else if(rating == 5){
                        sv_rating = 'Excellent'
                    }else {
    
                        sv_rating = 'Excellent'
                       }
                    ob['sv_rating'] = sv_rating
                    ob['sv_availability_of_rooms'] = 8
                    ob['imgs'] = imgs
                    
                    if(a_price){

                        ob = _.merge(ob, a_price)
                    }
                         
                       /*
                        item['sojourncode']= ob['sojourncode']
                        item['vernacularcode']= ob['vernacularcode']
                        item['sojourn_name']= ob['sojourn_name']
                         comData.my_data.push(item)
                        */
                       
    
                        comData.my_data.push(ob)
                        console.log('sv**OCT16 esqueryText partof sv_esquery_data*********', sv_esquery_data)
                        comData.sv_esquery_data =  sv_esquery_data  
                    });
                    comData.my_scr_id = rFob.my_scr_id
                   
                    dispatch(getEsSearchMultiplceCallsSuccess(comData))
                }
                else {
                    const comData = { items: []}
                    comData.sv_esquery_data = {
                        my_esqueryText: "mexco",
                        STARTDATE:"2023-10-24",
                        ENDDATE: "2023-11-27" , 
                        time_zone: "+01:00"
                
                      }
                    dispatch(getEsSearchSuccess(comData))
                }
                  
                   
                }
            )
        ).catch(
            e=>{dispatch(getEsSearchError(e))}
           
        )
    }
}


export function sojAndImagesSojournPaginate(sojPostRqFromPage, sv_esquery_data){
    console.log('SJ**JUN12Y2025 esqueryText*********', sv_esquery_data)
                       
    return dispatch => {
        dispatch(getEsSearchBegin())
       
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuilaCanQueryFinal`
        
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/shpoint/sojournsttr`
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/shpoint/sojourndol`
    //getResAsyncWorkingSvCanQueryTermsSojDyna
    ///sojournpoint/svsojournCanQueryFinalDyna
    let urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/svsojournCanQueryFinalDynaPaginate`
       //mock workin may12
       //http://localhost:8086/shpoint/sojourndol
       /*
         const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/svsojournCanQueryFinal`
      
      

        */
         let sojPostRq= {
            "svfields": [
                "sojourn_name",
                "code",
                "address",
                "sojourn_city",
                "countryCode",
                "stateCode",
                "postalCode",
                "destinationCode"
            ],
            "dates": {
                "STARTDATE_ITN_TZAWARE_EST": "2025-08-19",
                "ENDDATE_ITN_TZAWARE_EST": "2025-08-25",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata",
                "OP": "range"
            },
            "facets": {
                "PMSRoomCode": "APT"
            },
            "useCity": true,
            "dst": "BEVERLY HILLS",
            "esqueryChilds": "m0",
            "esqueryInfants": "i0",
            "esqueryAdults": "t1",
            "esqueryCabin": "ECONOMY",
            "esqueryTripType": "roundtrip",
            "svpageSize": 5,
            "codeKeys": [
                   
                ],
            "destinationCode": "MCO",
            "esqueryRooms": "r1"
        }
          let sojPostRqDyna = {
            "query": {
                "multi_match": {
                    "fields": [
                        "STATE",  "ADDRESS_LINE1", "COUNTRY_NAME", "SOJOURN_NAME"
                    ],
                    "query": "WorldMark Long Beach",
                    "operator": "or",
                    "fuzziness": "AUTO"
                }
            },
            "post_filter": {
                "range" : {
                    "STARTDATE": {
                        "gte" : "2023-10-24",
                        "lt" :  "2023-11-27",
                        "time_zone": "+01:00"
                    }
                }
              }
        }
        const HBD_URL = 'http://photos.hotelbeds.com/giata/'
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        let svpricegateway = ''
       
       console.log('sv****8')
       
        if(sojPostRqFromPage){
            let {facets} = sojPostRqFromPage
           
            
            /*sjjan9 start */
            
            if(facets.svpricegateway && (facets.svpricegateway.length > 3)){
                svpricegateway = facets.svpricegateway

            }
            /*svjan15 start*/
            if(svpricegateway == PRICEGATEWAY_AMD){
                //urlSoj =  `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/svsojournCanQueryFinalDynaPaginateAMDMARRIOTT`
                urlSoj =  `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/svsojournCanQueryFinalDynaPaginateAMDMARRIOTTGEO`
                if(facets.svchaincode && (facets.svchaincode.length > 3)){
                   
    
                }else{
                    facets.svchaincode = 'all'
                    
                   
                }
                if(facets.accommodationTypeCode && (facets.accommodationTypeCode.length > 1)){
                   
    
                }else{
                    facets.accommodationTypeCode = 'H'
                    
                   
                }
                
            }else if(svpricegateway == PRICEGATEWAY_SOJOURN){
                urlSoj =  `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/svsojournCanQueryFinalDynaPaginate`
                delete sojPostRqFromPage.esqueryIata
                if(facets.svchaincode && (facets.svchaincode.length > 3)){
                   
    
                }else{
                    facets.svchaincode = 'all'
                    
                   
                }
            }else{
                urlSoj =  `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/svsojournCanQueryFinalDynaPaginate`
                delete sojPostRqFromPage.esqueryIata
                if(facets.svchaincode && (facets.svchaincode.length > 3)){
                   
    
                }else{
                    facets.svchaincode = 'all'
                    
                   
                }
            }
            if(facets.svpricegateway ){
                
                delete facets.svpricegateway

            }
            /*sjjan9 end */
            sojPostRq = sojPostRqFromPage
           
        }
        /*
        "pagenumber":1,
	"my_scr_id":""
        */
        sojPostRq["pagenumber"] = 1
        sojPostRq["my_scr_id"] = ""

       

        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers})
        ])
        .then(
            axios.spread((rFobAx,r2)=>{
                let rFob = rFobAx.data
                let r = {data:{}}
                r.data = rFob.svo
                let p = {data:{}}
                p.data  = rFob.dbo
                let prices = []
                let prices_idx = []
                let a_price = null;
                let prices_map = {}
               
                if(p.data.length>0){
                    prices_idx = p.data
                }
                let aird = null
                let airc = null
                prices_idx.forEach(p_rec => {
                    let myh = p_rec['hotel']
                    //change this code as SPACEKEY is number
                    /*
                        let mys = p_rec['SPACEKEY']
                        let p =mys.indexOf('@')
                        let mytail = mys.substr(p, mys.length) 
                        
                        let myhead = myh['code']
                        let ckey =myhead + mytail
                         p_rec['SPACEKEY'] = ckey
                        p_rec['ABODE_SPACE_ID'] = myhead
                        p_rec['SOJOURN_NAME']= myh['sojourn_name']
                        if(p_rec['SPACE_KEY'] ){
                            p_rec['SPACE_KEY'] = ckey
                        }
                    */
                       
                        p_rec['ranking'] = myh['ranking'] ?myh['ranking'] : "NA"
                        p_rec['web'] = myh['web'] ?myh['web'] : "http://svrenaissance.org/svceo"

                        if(p_rec['terminals'] &&  p_rec['terminals'][0]){
                            let ta =  p_rec['terminals'][0]
                            aird = ta["distance"]
                            airc = ta["terminalCode"]
                            p_rec['airportDistance'] =  `${aird} miles from  ${airc} airport`
                        }
                    let p_item = {}
                    let p_lc = {}
                    p_item = p_rec
                    p_lc =lowercaseKeys(p_item)
                    prices.push(p_lc)
                   
                });
                prices.forEach(p => {
                    let k =p.spacekey
                    prices_map[k] = p
                });
                console.log('sv**SPET9 MONDAY **************** Prices_map START')
                console.log(prices_map)
                console.log('sv**SPET9 MONDAY **************** Prices_map END')
                if(r.data.length>0){
                   
                    const ar = r.data
                    const comData = { my_data: []}
                    let item , ob, upperOb
                    if( r2.data && r2.data.images[0]){
                        comData.my_images = r2.data.images[0]
                    }
                    //get path and concat them wil base url
                  
                    ar.forEach(a_rec => {
                        let myh = a_rec['hotel']
                        /*
                        let mys = a_rec['SPACEKEY']
                        let p =mys.indexOf('@')
                        let mytail = mys.substr(p, mys.length) 
                        
                        let myhead = myh['code']
                        let ckey =myhead + mytail
                        a_rec['SPACEKEY'] = ckey
                        if(a_rec['SPACE_KEY'] ){
                            a_rec['SPACE_KEY'] = ckey
                            a_rec['SOJOURNCODE'] = ckey
                            a_rec['SPACE_INV_ID']= ckey
                            a_rec['ABODE_SPACE_ID'] = ckey
                            a_rec['ABODESPACEID'] = ckey
                            
                        }
                        */
                        a_rec['ranking'] = myh['ranking'] ?myh['ranking'] : "NA"
                        a_rec['web'] = myh['web'] ?myh['web'] : "NA"

                        a_rec['SOJOURN_NAME']= myh['sojourn_name']
                        a_rec["COUNTRY_NAME"]= myh['countryCode']
                        let address_s = a_rec["ADDRESS_LINE1"]
                        const {address} = myh
                        let anum_s = address.number ?address.number : ''
                       
                        if(myh['address']){
                            address_s =  anum_s + " "+address.street
                        }
                        a_rec["ADDRESS_LINE1"] = address_s
                        item = {}
                        let hbd_images  = a_rec.hotel.images
                        let imgs = []
                        //hbd_images  = hbd_images? hbd_images : r2.data.images
                        if(hbd_images && (hbd_images.length > 0) ){
                            hbd_images.forEach(im =>{
                                let sim =  HBD_URL +  im.path 
                                imgs.push(sim)
                               })
                        }else{
                            imgs = r2.data.images
                        }
                       
                        if(imgs.length > 0){
                            comData.my_images = imgs
                        }

                        upperOb = a_rec
                        ob =lowercaseKeys(upperOb)
                        //svjun9
                        let k_sv = ob['spacekey']
                        a_price = prices_map[k_sv]
                        let assets = a_price['assets']
                        const aroom = assets[0]
                        const {rates} = aroom
                        const arate = rates[0]
                        let {taxes} = arate
                        a_rec['product_cost_amount'] = arate['net']

                        //svjun9 end

                        let HB_REVIEWS_HW = [
                            {
                                "rate": 4,
                                "reviewCount": 15,
                                "type": "HOTELBEDS"
                            }
                        ]
                        let reviews_ob = a_price["reviews"] ?a_price["reviews"] : HB_REVIEWS_HW
                        
                        let review_ob = reviews_ob[0]
                       //num_reviews
                        let rating = (review_ob['rate']? review_ob['rate'] : 0 )
                        let reviewCount = (review_ob[ "reviewCount"]? review_ob[ "reviewCount"] : 0 )
                        ob['num_reviews'] = reviewCount
                        //let rating = (ob['svr_vep_rating']? ob['svr_vep_rating'] : 0 )
                        let sv_rating = 'Excellent'
                       if(rating == 0){
                        sv_rating = 'Excellent'
    
                       }else if(rating == 1){
    
                        sv_rating = 'Poor'
                    }else if(rating == 2){
                        sv_rating = 'Fair'
                    }else if(rating == 3){
    
                        sv_rating = 'Recommend'
                    }else if(rating == 4){
                        sv_rating = 'Favorite'
                    }else if(rating == 5){
                        sv_rating = 'Excellent'
                    }else {
    
                        sv_rating = 'Excellent'
                       }
                    ob['sv_rating'] = sv_rating
                    ob['sv_availability_of_rooms'] = 8
                    ob['imgs'] = imgs
                    
                    if(a_price){

                        ob = _.merge(ob, a_price)
                    }
                         
                       /*
                        item['sojourncode']= ob['sojourncode']
                        item['vernacularcode']= ob['vernacularcode']
                        item['sojourn_name']= ob['sojourn_name']
                         comData.my_data.push(item)
                        */
                       
    
                        comData.my_data.push(ob)
                        console.log('sv**OCT16 esqueryText partof sv_esquery_data*********', sv_esquery_data)
                        comData.sv_esquery_data =  sv_esquery_data  
                    });
                    comData.my_scr_id = rFob.my_scr_id
                   
                   
                    dispatch(getEsSearchMultiplceCallsSuccess(comData))
                }
                else {
                    const comData = { items: []}
                    comData.sv_esquery_data = {
                        my_esqueryText: "mexco",
                        STARTDATE:"2025-10-24",
                        ENDDATE: "2025-11-27" , 
                        time_zone: "+01:00"
                
                      }
                      if(sv_esquery_data){
                        comData.sv_esquery_data = sv_esquery_data
                      }
                      /*sjjun19 start
                       dispatch(getEsSearchSuccess(comData))

                      */
                    dispatch(getEsSearchServerError(comData))
                }
                  
                   
                }
            )
        ).catch(
            e=>{dispatch(getEsSearchError(e))}
           
        )
    }
}

/*sjjun12 end*/
  /*sv sept7 start */

export function sojAndImagesSojourn_apartment(sojPostRqFromPage, sv_esquery_data){
    console.log('sv**MAY3Y2025 esqueryText*********', sv_esquery_data)
                       
    return dispatch => {
        dispatch(getEsSearchBegin())
       
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuilaCanQueryFinal`
        
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/shpoint/sojournsttr`
        const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/svsojournCanQueryFinalDyna`
      /*

       let sojPostRq = {
        
    
           "dates": {
                "STARTDATE_ITN_TZAWARE_EST": "2025-04-19",
                "ENDDATE_ITN_TZAWARE_EST": "2025-04-25",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata",
                "OP": "range"
            },
            "facets": {
                "PMSRoomCode": "APT"
                },
            "useCity":true,
            "dst": "PLAYA DE LAS AMERICAS",
            "esqueryChilds": "m0",
            "esqueryInfants": "i0",
            "esqueryAdults": "t1",
            "esqueryCabin": "ECONOMY",
            "esqueryTripType": "roundtrip",
            "svpageSize": 5
        }
      */
       let sojPostRq = {
        "svfields": [
            "images",
            "sojourn_name",
           // "address",
           
            "code",
            "sojournGeocode",
            "categoryCode",
            "categoryGroupCode",
            "accommodationTypeCode",
    
            "sojourn_city",
            "countryCode",
            "stateCode",
            "postalCode",
             "countryCode",
            "destinationCode"
            
        ],
    
           "dates": {
                "STARTDATE_ITN_TZAWARE_EST": "2025-04-19",
                "ENDDATE_ITN_TZAWARE_EST": "2025-04-25",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata",
                "OP": "range"
            },
            "facets": {
                "PMSRoomCode": "APT"
                },
            "useCity":true,
            "dst": "PLAYA DE LAS AMERICAS",
            "esqueryChilds": "m0",
            "esqueryInfants": "i0",
            "esqueryAdults": "t1",
            "esqueryCabin": "ECONOMY",
            "esqueryTripType": "roundtrip",
            "svpageSize": 5
        }
        
       //mock workin may12
       /*
         const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/svsojournCanQueryFinal`
      
       let sojPostRq= {
            "hotelIds": "HLPAR266",
            "adults": 1,
            "checkInDate": "2025-11-22",
            "roomQuantity": 1
        }
        */
          let sojPostRqDyna = {
            "query": {
                "multi_match": {
                    "fields": [
                        "STATE",  "ADDRESS_LINE1", "COUNTRY_NAME", "SOJOURN_NAME"
                    ],
                    "query": "WorldMark Long Beach",
                    "operator": "or",
                    "fuzziness": "AUTO"
                }
            },
            "post_filter": {
                "range" : {
                    "STARTDATE": {
                        "gte" : "2023-10-24",
                        "lt" :  "2023-11-27",
                        "time_zone": "+01:00"
                    }
                }
              }
        }
        const HBD_URL = 'http://photos.hotelbeds.com/giata/'
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        if(sojPostRqFromPage){
            sojPostRq = sojPostRqFromPage
        }
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers})
        ])
        .then(
            axios.spread((rFobAx,r2)=>{
                let rFob = rFobAx.data
                let r = {data:{}}
                r.data = rFob.svo
                let p = {data:{}}
                p.data  = rFob.dbo
                let prices = []
                let prices_idx = []
                let a_price = null;
                let prices_map = {}
               
                if(p.data.length>0){
                    prices_idx = p.data
                }
                let aird = null
                let airc = null
                prices_idx.forEach(p_rec => {
                    let myh = p_rec['hotel']
                    //change this code as SPACEKEY is number
                    /*
                        let mys = p_rec['SPACEKEY']
                        let p =mys.indexOf('@')
                        let mytail = mys.substr(p, mys.length) 
                        
                        let myhead = myh['code']
                        let ckey =myhead + mytail
                         p_rec['SPACEKEY'] = ckey
                        p_rec['ABODE_SPACE_ID'] = myhead
                        p_rec['SOJOURN_NAME']= myh['sojourn_name']
                        if(p_rec['SPACE_KEY'] ){
                            p_rec['SPACE_KEY'] = ckey
                        }
                    */
                   
                        p_rec['ranking'] = myh['ranking'] ?myh['ranking'] : "NA"
                        p_rec['web'] = myh['web'] ?myh['web'] : "http://svrenaissance.org/svceo"

                        if(p_rec['terminals'] &&  p_rec['terminals'][0]){
                            let ta =  p_rec['terminals'][0]
                            aird = ta["distance"]
                            airc = ta["terminalCode"]
                            p_rec['airportDistance'] =  `${aird} miles from  ${airc} airport`
                        }
                    let p_item = {}
                    let p_lc = {}
                    p_item = p_rec
                    p_lc =lowercaseKeys(p_item)
                    prices.push(p_lc)
                   
                });
                prices.forEach(p => {
                    let k =p.spacekey
                    prices_map[k] = p
                });
                console.log('sv**SPET9 MONDAY **************** Prices_map START')
                console.log(prices_map)
                console.log('sv**SPET9 MONDAY **************** Prices_map END')
                if(r.data.length>0){
                    const ar = r.data
                    const comData = { my_data: []}
                    let item , ob, upperOb
                    if( r2.data && r2.data.images[0]){
                        comData.my_images = r2.data.images[0]
                    }
                    //get path and concat them wil base url
                  
                    ar.forEach(a_rec => {
                        let myh = a_rec['hotel']
                        /*
                        let mys = a_rec['SPACEKEY']
                        let p =mys.indexOf('@')
                        let mytail = mys.substr(p, mys.length) 
                        
                        let myhead = myh['code']
                        let ckey =myhead + mytail
                        a_rec['SPACEKEY'] = ckey
                        if(a_rec['SPACE_KEY'] ){
                            a_rec['SPACE_KEY'] = ckey
                            a_rec['SOJOURNCODE'] = ckey
                            a_rec['SPACE_INV_ID']= ckey
                            a_rec['ABODE_SPACE_ID'] = ckey
                            a_rec['ABODESPACEID'] = ckey
                            
                        }
                        */
                        a_rec['ranking'] = myh['ranking'] ?myh['ranking'] : "NA"
                        a_rec['web'] = myh['web'] ?myh['web'] : "NA"

                        a_rec['SOJOURN_NAME']= myh['sojourn_name']
                        a_rec["COUNTRY_NAME"]= myh['countryCode']
                        let address_s = a_rec["ADDRESS_LINE1"]
                        const {address} = myh
                        if(myh['address']){
                            address_s =  address.number + " "+address.street
                        }
                        a_rec["ADDRESS_LINE1"] = address_s
                        item = {}
                        let hbd_images  = a_rec.hotel.images
                        let imgs = []
                        hbd_images.forEach(im =>{
                         let sim =  HBD_URL +  im.path 
                         imgs.push(sim)
                        })
                        if(imgs.length > 0){
                            comData.my_images = imgs
                        }

                        upperOb = a_rec
                        ob =lowercaseKeys(upperOb)
                        
                        let k_sv = ob['spacekey']
                        a_price = prices_map[k_sv]
                        let reviews_ob = a_price["reviews"]
                        let assets_ob = a_price["assets"]
                        if( assets_ob &&  assets_ob.length > 0){
                            ob['roomMeta']  = assets_ob[0]["name"]
                        }else{
                            ob['roomMeta']  = "2 SVQueen Bed"
                        }
                       

                        let review_ob = reviews_ob[0]
                       //num_reviews
                        let rating = (review_ob['rate']? review_ob['rate'] : 0 )
                        let reviewCount = (review_ob[ "reviewCount"]? review_ob[ "reviewCount"] : 0 )
                        ob['num_reviews'] = reviewCount
                        //let rating = (ob['svr_vep_rating']? ob['svr_vep_rating'] : 0 )
                        let sv_rating = 'Excellent'
                       if(rating == 0){
                        sv_rating = 'Excellent'
    
                       }else if(rating == 1){
    
                        sv_rating = 'Poor'
                    }else if(rating == 2){
                        sv_rating = 'Fair'
                    }else if(rating == 3){
    
                        sv_rating = 'Recommend'
                    }else if(rating == 4){
                        sv_rating = 'Favorite'
                    }else if(rating == 5){
                        sv_rating = 'Excellent'
                    }else {
    
                        sv_rating = 'Excellent'
                       }
                    ob['sv_rating'] = sv_rating
                    ob['sv_availability_of_rooms'] = 8
                    ob['imgs'] = imgs
                    
                    if(a_price){

                        ob = _.merge(ob, a_price)
                    }
                         
                       /*
                        item['sojourncode']= ob['sojourncode']
                        item['vernacularcode']= ob['vernacularcode']
                        item['sojourn_name']= ob['sojourn_name']
                         comData.my_data.push(item)
                        */
                       
    
                        comData.my_data.push(ob)
                        console.log('sv**OCT16 esqueryText partof sv_esquery_data*********', sv_esquery_data)
                        comData.sv_esquery_data =  sv_esquery_data  
                    });
                   
                   
                    dispatch(getEsSearchMultiplceCallsSuccess(comData))
                }
                else {
                    const comData = { items: []}
                    comData.sv_esquery_data = {
                        my_esqueryText: "mexco",
                        STARTDATE:"2023-10-24",
                        ENDDATE: "2023-11-27" , 
                        time_zone: "+01:00"
                
                      }
                    dispatch(getEsSearchSuccess(comData))
                }
                  
                   
                }
            )
        ).catch(
            e=>{dispatch(getEsSearchError(e))}
           
        )
    }
}

  /*sept7 end */

export function sojAndImagesSV_old(sojPostRqFromPage){
    return dispatch => {
        dispatch(getEsSearchBegin())
       
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
        const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuilaCanQuery`
        let sojPostRq_old = {
            "query": {
              "match": {
                "sojourn_name": {
                  "query": "mancreek",
                  "operator": "and"
                }
              }
            }
          }

          let sojPostRq = {
            "query": {
                "multi_match": {
                    "fields": [
                        "STATE",  "ADDRESS_LINE1", "COUNTRY_NAME", "SOJOURN_NAME"
                    ],
                    "query": "WorldMark Long Beach",
                    "operator": "or",
                    "fuzziness": "AUTO"
                }
            },
            "post_filter": {
                "range" : {
                    "STARTDATE": {
                        "gte" : "2023-10-24",
                        "lt" :  "2023-11-27",
                        "time_zone": "+01:00"
                    }
                }
              }
        }
       
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        if(sojPostRqFromPage){
            sojPostRq = sojPostRqFromPage
        }
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers})
        ])
        .then(
            axios.spread((r,r2)=>{
                if(r.data.hits.hits.length>0){
                    const ar = r.data.hits.hits
                    const comData = { my_data: []}
                    let item , ob, upperOb
                    ar.forEach(a_rec => {
                        item = {}
                       
                        upperOb = a_rec['_source']
                        ob =lowercaseKeys(upperOb)

                        let rating = (ob['svr_vep_rating']? ob['svr_vep_rating'] : 0 )
                        let sv_rating = 'Excellent'
                       if(rating == 0){
                        sv_rating = 'Excellent'
    
                       }else if(rating == 1){
    
                        sv_rating = 'Poor'
                    }else if(rating == 2){
                        sv_rating = 'Fair'
                    }else if(rating == 3){
    
                        sv_rating = 'Recommend'
                    }else if(rating == 4){
                        sv_rating = 'Favorite'
                    }else if(rating == 5){
                        sv_rating = 'Excellent'
                    }else {
    
                        sv_rating = 'Excellent'
                       }
                       ob['sv_rating'] = sv_rating
                       ob['sv_availability_of_rooms'] = 8
                        /*
                        item['sojourncode']= ob['sojourncode']
                        item['vernacularcode']= ob['vernacularcode']
                        item['sojourn_name']= ob['sojourn_name']
                         comData.my_data.push(item)
                        */
    
    
                        comData.my_data.push(ob)
                    });
                    if( r2.data && r2.data[0]){
                        comData.my_images = r2.data[0]
                    }
                   
                    dispatch(getEsSearchMultiplceCallsSuccess(comData))
                }
                else {
                    const comData = { items: []}
                    dispatch(getEsSearchSuccess(comData))
                }
                  
                   
                }
            )
        ).catch(
            e=>{dispatch(getEsSearchError(e))}
           
        )
    }
}

/**facet lsiteview */
export function sojAndImagesSVFacet_old(sojPostRqFromPage){
    return dispatch => {
        dispatch(getEsSearchBegin())
       //svuilaFacetView
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
        const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuilaFacetViewCanQuery`
        let sojPostRq_old = {
            "query": {
              "match": {
                "sojourn_name": {
                  "query": "mancreek",
                  "operator": "and"
                }
              }
            }
          }

          let sojPostRq = {
            "query": {
                "multi_match": {
                    "fields": [
                        "STATE",  "ADDRESS_LINE1", "COUNTRY_NAME", "SOJOURN_NAME"
                    ],
                    "query": "WorldMark Long Beach",
                    "operator": "or",
                    "fuzziness": "AUTO"
                }
            },
            "post_filter": {
                "range" : {
                    "STARTDATE": {
                        "gte" : "2023-10-24",
                        "lt" :  "2023-11-27",
                        "time_zone": "+01:00"
                    }
                }
              }
        }
       
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        if(sojPostRqFromPage){
            sojPostRq = sojPostRqFromPage
        }
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers})
        ])
        .then(
            axios.spread((r,r2)=>{
                if(r.data.hits.hits.length>0){
                    const ar = r.data.hits.hits
                    const comData = { my_data: []}
                    let item , ob, upperOb
                    ar.forEach(a_rec => {
                        item = {}
                       
                        upperOb = a_rec['_source']
                        ob =lowercaseKeys(upperOb)

                        let rating = (ob['svr_vep_rating']? ob['svr_vep_rating'] : 0 )
                        let sv_rating = 'Excellent'
                       if(rating == 0){
                        sv_rating = 'Excellent'
    
                       }else if(rating == 1){
    
                        sv_rating = 'Poor'
                    }else if(rating == 2){
                        sv_rating = 'Fair'
                    }else if(rating == 3){
    
                        sv_rating = 'Recommend'
                    }else if(rating == 4){
                        sv_rating = 'Favorite'
                    }else if(rating == 5){
                        sv_rating = 'Excellent'
                    }else {
    
                        sv_rating = 'Excellent'
                       }
                       ob['sv_rating'] = sv_rating
                       ob['sv_availability_of_rooms'] = 8
                        /*
                        item['sojourncode']= ob['sojourncode']
                        item['vernacularcode']= ob['vernacularcode']
                        item['sojourn_name']= ob['sojourn_name']
                         comData.my_data.push(item)
                        */
    
    
                        comData.my_data.push(ob)
                    });
                    if( r2.data && r2.data[0]){
                        comData.my_images = r2.data[0]
                    }
                   
                    dispatch(getEsSearchMultiplceCallsSuccess(comData))
                }
                else {
                    const comData = { items: []}
                    dispatch(getEsSearchSuccess(comData))
                }
                  
                   
                }
            )
        ).catch(
            e=>{dispatch(getEsSearchError(e))}
           
        )
    }
}
const headers = {'Content-Type': 'application/json'}
export function sojAndImagesSV_Workigng_latest(sojPostRqFromPage){
    return dispatch => {
        dispatch(getEsSearchBegin())
       
        
        const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/svsearchElastic`
        let sojPostRq = {
            "query": {
                "multi_match": {
                    "fields": [
                        "SOJOURN_NAME", "EN_REGION_HIERARCHY"
                    ],
                    "query": "WorldMark ",
                    "operator": "or",
                    "fuzziness": "AUTO"
                }
            }
        }
       
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        if(sojPostRqFromPage){
            sojPostRq = sojPostRqFromPage
           /*
           sojPostRq = {
            "query": {
              "match_all": {}
            }
          }*/
        }
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers})
        ])
        .then(
            axios.spread((r,r2)=>{
                if(r.data.hits.hits.length>0){
                    const ar = r.data.hits.hits
                    const comData = { my_data: []}
                    let item , ob, upperOb
                    ar.forEach(a_rec => {
                        item = {}
                        upperOb = a_rec['_source']
                        ob =lowercaseKeys(upperOb)
                        let rating = (ob['svr_vep_rating']? ob['svr_vep_rating'] : 0 )
                        let sv_rating = 'Excellent'
                       if(rating == 0){
                        sv_rating = 'Excellent'
    
                       }else if(rating == 1){
    
                        sv_rating = 'Poor'
                    }else if(rating == 2){
                        sv_rating = 'Fair'
                    }else if(rating == 3){
    
                        sv_rating = 'Recommend'
                    }else if(rating == 4){
                        sv_rating = 'Favorite'
                    }else if(rating == 5){
                        sv_rating = 'Excellent'
                    }else {
    
                        sv_rating = 'Excellent'
                       }
                       ob['sv_rating'] = sv_rating
                       ob['sv_availability_of_rooms'] = 8
                        /*
                        item['sojourncode']= ob['sojourncode']
                        item['vernacularcode']= ob['vernacularcode']
                        item['sojourn_name']= ob['sojourn_name']
                         comData.my_data.push(item)
                        */
    
    
                        comData.my_data.push(ob)
                    });
                    if( r2.data && r2.data[0]){
                        comData.my_images = r2.data[0]
                    }
                   
                    dispatch(getEsSearchMultiplceCallsSuccess(comData))
                }
                else {
                    const comData = { items: []}
                    dispatch(getEsSearchSuccess(comData))
                }
                  
                   
                }
            )
        ).catch(
            e=>{dispatch(getEsSearchError(e))}
           
        )
    }
}


export function sojAndImagesSV_uses_es_lowercaseKeys_working(sojPostRqFromPage){
    return dispatch => {
        dispatch(getEsSearchBegin())
       
        const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
        let sojPostRq = {
            "query": {
              "match": {
                "sojourn_name": {
                  "query": "mancreek",
                  "operator": "and"
                }
              }
            }
          }
       
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        if(sojPostRqFromPage){
            sojPostRq = sojPostRqFromPage
        }
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers})
        ])
        .then(
            axios.spread((r,r2)=>{
                if(r.data.hits.hits.length>0){
                    const ar = r.data.hits.hits
                    const comData = { my_data: []}
                    let item , ob
                    ar.forEach(a_rec => {
                        item = {}
                        ob = a_rec['_source']
                        let rating = (ob['svr_vep_rating']? ob['svr_vep_rating'] : 0 )
                        let sv_rating = 'Excellent'
                       if(rating == 0){
                        sv_rating = 'Excellent'
    
                       }else if(rating == 1){
    
                        sv_rating = 'Poor'
                    }else if(rating == 2){
                        sv_rating = 'Fair'
                    }else if(rating == 3){
    
                        sv_rating = 'Recommend'
                    }else if(rating == 4){
                        sv_rating = 'Favorite'
                    }else if(rating == 5){
                        sv_rating = 'Excellent'
                    }else {
    
                        sv_rating = 'Excellent'
                       }
                       ob['sv_rating'] = sv_rating
                       ob['sv_availability_of_rooms'] = 8
                        /*
                        item['sojourncode']= ob['sojourncode']
                        item['vernacularcode']= ob['vernacularcode']
                        item['sojourn_name']= ob['sojourn_name']
                         comData.my_data.push(item)
                        */
    
    
                        comData.my_data.push(ob)
                    });
                    if( r2.data && r2.data[0]){
                        comData.my_images = r2.data[0]
                    }
                   
                    dispatch(getEsSearchMultiplceCallsSuccess(comData))
                }
                else {
                    const comData = { items: []}
                    dispatch(getEsSearchSuccess(comData))
                }
                  
                   
                }
            )
        ).catch(
            e=>{dispatch(getEsSearchError(e))}
           
        )
    }
}

/*end.....*/
/*  
export function sojAndImagesOls(nameQParam){
   
    const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
    const sojPostRq = {
        "query": {
          "match": {
            "sojourn_name": {
              "query": "mancreek",
              "operator": "and"
            }
          }
        }
      }
   

    const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
    axios.all([
        axios.post(urlSoj, sojPostRq, {headers:headers}),
        axios.get(urlSojImages, {headers:headers})
    ])
    .then(
        axios.spread((r,r2)=>{
            if(r.data.hits.hits.length>0){
                const ar = r.data.hits.hits
                const comData = { my_data: []}
                let item , ob
                ar.forEach(a_rec => {
                    item = {}
                    ob = a_rec['_source']
                    let rating = (ob['svr_vep_rating']? ob['svr_vep_rating'] : 0 )
                    let sv_rating = 'Excellent'
                   if(rating == 0){
                    sv_rating = 'Excellent'

                   }else if(rating == 1){

                    sv_rating = 'Poor'
                }else if(rating == 2){
                    sv_rating = 'Fair'
                }else if(rating == 3){

                    sv_rating = 'Recommend'
                }else if(rating == 4){
                    sv_rating = 'Favorite'
                }else if(rating == 5){
                    sv_rating = 'Excellent'
                }else {

                    sv_rating = 'Excellent'
                   }
                   ob['sv_rating'] = sv_rating
                   ob['sv_availability_of_rooms'] = 8
                    


                    comData.my_data.push(ob)
                });
                if( r2.data && r2.data[0]){
                    comData.my_images = r2.data[0]
                }
               
                dispatch(getEsSearchMultiplceCallsSuccess(comData))
            }
            else {
                const comData = { items: []}
                dispatch(getEsSearchSuccess(comData))
            }
              
               
            }
        )
    ).catch(
        e => {dispatch(getIncidentsError(e.message))}
    )
}
*/
export function getSoDetailsSojourn(nameQParam){
    return dispatch => {
        dispatch(getEsSearchBegin())
       
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        const body = {
            "query": {
              "match": {
                "sojourn_name": {
                  "query": "mancreek",
                  "operator": "and"
                }
              }
            }
          }
          
        axios.post(url, body, {headers:headers})
        .then(
            r => {
                if(r.data.hits.hits.length>0){
                    const ar = r.data.hits.hits
                    const comData = { my_data: []}
                    let item , ob
                    ar.forEach(a_rec => {
                        item = {}
                        ob = a_rec['_source']
                        let rating = (ob['svr_vep_rating']? ob['svr_vep_rating'] : 0 )
                        let sv_rating = 'Excellent'
                       if(rating == 0){
                        sv_rating = 'Excellent'

                       }else if(rating == 1){

                        sv_rating = 'Poor'
                    }else if(rating == 2){
                        sv_rating = 'Fair'
                    }else if(rating == 3){

                        sv_rating = 'Recommend'
                    }else if(rating == 4){
                        sv_rating = 'Favorite'
                    }else if(rating == 5){
                        sv_rating = 'Excellent'
                    }else {

                        sv_rating = 'Excellent'
                       }
                       ob['sv_rating'] = sv_rating
                       ob['sv_availability_of_rooms'] = 8
                        /*
                        item['sojourncode']= ob['sojourncode']
                        item['vernacularcode']= ob['vernacularcode']
                        item['sojourn_name']= ob['sojourn_name']
                         comData.my_data.push(item)
                        */


                        comData.my_data.push(ob)
                    });

                   
                    dispatch(getEsSearchSuccess(comData))
                }
                else {
                    const comData = { items: []}
                    dispatch(getEsSearchSuccess(comData))
                }
            }
        ).catch(
            e=>dispatch(getEsSearchError(e))
        )
    }
}


export const getEsSearchSuccess = (data) => dispatch => {
    dispatch({
        type: typesSojProd.GET_SOJ_PROD_SUCCESS,
        payload: data
    })
}

/*sjjun19 start*/


export const getEsSearchServerError = (data) => dispatch => {
    let eob = {
        "timestamp": "2015-08-23T02:27:18.038+0000",
        "status": 500,
        "error": "FlyServer Error",
        "message": "No Sojourns Found.Please refinse search and try again",
        "path": "/kk/svaddressDetailPost"
    }
    dispatch({
        type:typesSojProd.GET_SOJ_PROD_ERROR,
        error:eob
    })
}


/*sjjun19 end*/

export const getEsSearchMultiplceCallsSuccess = (data) => dispatch => {
    dispatch({
        type: typesSojProd.GET_SOJ_PROD_SUCCESS,
        payload: data
    })
}

export const getEsSearchBegin = () => dispatch => {
    dispatch({
        type:typesSojProd.GET_SOJ_PROD_BEGIN
        
    })
}

export const getEsSearchError = (e) =>dispatch => {
    dispatch({
        type:typesSojProd.GET_SOJ_PROD_ERROR,
        error:e
    })
}


export const getEsEmptySuccess = (data) => dispatch => {
    dispatch({
        type: "GET_SOJ_EMPTY_SUCCESS",
        payload: data
    })
}


const getDinoRecords = () => {
    const headers = {'content-type': 'application/json'};
    let url = "http://localhost:8080/svapi/coreend/control";
    let ob = {'content-type': 'application/json'};
    return axios.get(url, {headers: ob})
}

export const loadDinoAction = async (dispatch) => {
    const response = await getDinoRecords();
    console.log(response);
    if (response) {
        let payload = {
            my_data: response.data
        }
        return dispatch({
            type: "dino-success",
            payload: payload
        });
    } else {
        console.log("Server error");
    }
}

export const loadRadioAction =  (dispatch, radio_data) => {
    console.log('dinoActions recvd radio)data');
     console.log(radio_data) ;
     return dispatch({
        type: "radio-success",
        payload: radio_data
    });
}


export function sojAndImagesSojournFacet_old(sojPostRqFromPage, sv_esquery_data){
    
    console.log("svoct17 sojAndImagesSojournFacet ******sv_esquery_data", sv_esquery_data)
    return dispatch => {
        dispatch(getEsSearchBegin())
       //svuilaFacetView
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuilaFacetViewCanQuery`
       // const urlSoj = `${SV_SOJ_SVDJMOCK_ADDRESS}/trip/absvfacetab/`
       const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/svsojournCanQueryFinalDyna`
   

          let sojPostRq = {
            "dates": {
                "STARTDATE_ITN_TZAWARE_EST": "2025-11-25",
                "ENDDATE_ITN_TZAWARE_EST": "2025-11-27",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "+01:00",
                "OP": "range"
            },
            "facets": {
               "EN_AMENITY_NAME_LVL.keyword": ["Health Club", "WiFi Available"]
            },
            "loc": "mexico"
    
        }
       
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        if(sojPostRqFromPage){
            sojPostRq = sojPostRqFromPage
           delete sojPostRq['facets']['EN_ACTIVITY_NAME_LVL.keyword']
           let {SVR_VEP_RATING} =sojPostRq['facets']
           /*
           let categoryCode = []

           SVR_VEP_RATING.forEach(v=>{
               categoryCode.push(v + 'LUX')
           })
          //  "4LUX",
          */
          let categoryCode = "4LUX"
          sojPostRq['facets']['categoryCode'] = categoryCode
          delete sojPostRq['facets']['SVR_VEP_RATING']
           delete sojPostRq['facets']['EN_ACTIVITY_NAME_LVL.keyword']
        }
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers})
        ])
        .then(
            axios.spread((r,r2)=>{
                if(r.data.hits.hits.length>0){
                    const ar = r.data.hits.hits
                    const comData = { my_data: []}
                    let item , ob, upperOb
                    ar.forEach(a_rec => {
                        item = {}
                       
                        upperOb = a_rec['_source']
                        ob =lowercaseKeys(upperOb)

                        let rating = (ob['svr_vep_rating']? ob['svr_vep_rating'] : 0 )
                        let sv_rating = 'Excellent'
                       if(rating == 0){
                        sv_rating = 'Excellent'
    
                       }else if(rating == 1){
    
                        sv_rating = 'Poor'
                    }else if(rating == 2){
                        sv_rating = 'Fair'
                    }else if(rating == 3){
    
                        sv_rating = 'Recommend'
                    }else if(rating == 4){
                        sv_rating = 'Favorite'
                    }else if(rating == 5){
                        sv_rating = 'Excellent'
                    }else {
    
                        sv_rating = 'Excellent'
                       }
                       ob['sv_rating'] = sv_rating
                       ob['sv_availability_of_rooms'] = 8
                        
    
    
                        comData.my_data.push(ob)
                    });
                    if( r2.data && r2.data[0]){
                        comData.my_images = r2.data[0]
                    }
                    console.log('sv**OCT16 esqueryText partof sv_esquery_data*********', sv_esquery_data)
                    comData.sv_esquery_data =  sv_esquery_data  
                   
                    dispatch(getEsSearchMultiplceCallsSuccess(comData))
                }
                else {
                    const comData = { items: []}
                    comData.sv_esquery_data = {
                        my_esqueryText: "mexco",
                        STARTDATE:"2023-10-24",
                        ENDDATE: "2023-11-27" , 
                        time_zone: "+01:00"
                
                      }
                    dispatch(getEsSearchSuccess(comData))
                }
                  
                   
                }
            )
        ).catch(
            e=>{dispatch(getEsSearchError(e))}
           
        )
    }
}


/*SVJUN6 GOOD */
export function sojAndImagesSojournFacet_jun18y25(sojPostRqFromPage, sv_esquery_data){
    
    console.log("svoct17 sojAndImagesSojournFacet ******sv_esquery_data", sv_esquery_data)
    return dispatch => {
        dispatch(getEsSearchBegin())
       //svuilaFacetView
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuilaFacetViewCanQuery`
       // const urlSoj = `${SV_SOJ_SVDJMOCK_ADDRESS}/trip/absvfacetab/`
       //sjFacetOnlyDyna
       const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/sjFacetOnlyDyna   `
   

          let sojPostRq = {
            "dates": {
                "STARTDATE_ITN_TZAWARE_EST": "2025-11-25",
                "ENDDATE_ITN_TZAWARE_EST": "2025-11-27",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "+01:00",
                "OP": "range"
            },
            "facets": {
               "EN_AMENITY_NAME_LVL.keyword": ["Health Club", "WiFi Available"]
            },
            "loc": "mexico"
    
        }
        const HBD_URL = 'http://photos.hotelbeds.com/giata/'
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
     
        if(sojPostRqFromPage){
            sojPostRq = sojPostRqFromPage
           delete sojPostRq['facets']['EN_ACTIVITY_NAME_LVL.keyword']
           let {SVR_VEP_RATING} =sojPostRq['facets']
           
           let categoryCodes = []

           SVR_VEP_RATING.forEach(v=>{
            categoryCodes.push(v + 'LUX')
           })
          //  "4LUX",
          
       /*
          let categoryCode =  categoryCodes[0] ?categoryCodes[0]: "4LUX"
          sojPostRq['facets']['categoryCode'] = categoryCode
          */
          sojPostRq['facets']['categoryCode'] = categoryCodes
          delete sojPostRq['facets']['SVR_VEP_RATING']
          // delete sojPostRq['facets']['EN_ACTIVITY_NAME_LVL.keyword']
        }

        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers})
        ])
        .then(
            axios.spread((rFobAx,r2)=>{
                let rFob = rFobAx.data
                let r = {data:{}}
                r.data = rFob.svo
                let p = {data:{}}
                p.data  = rFob.dbo
                let prices = []
                let prices_idx = []
                let a_price = null;
                let prices_map = {}
               
                if(p.data.length>0){
                    prices_idx = p.data
                }
                let aird = null
                let airc = null
                prices_idx.forEach(p_rec => {
                    let myh = p_rec['hotel']
                    //change this code as SPACEKEY is number
                    /*
                        let mys = p_rec['SPACEKEY']
                        let p =mys.indexOf('@')
                        let mytail = mys.substr(p, mys.length) 
                        
                        let myhead = myh['code']
                        let ckey =myhead + mytail
                         p_rec['SPACEKEY'] = ckey
                        p_rec['ABODE_SPACE_ID'] = myhead
                        p_rec['SOJOURN_NAME']= myh['sojourn_name']
                        if(p_rec['SPACE_KEY'] ){
                            p_rec['SPACE_KEY'] = ckey
                        }
                    */
                       
                        p_rec['ranking'] = myh['ranking'] ?myh['ranking'] : "NA"
                        p_rec['web'] = myh['web'] ?myh['web'] : "http://svrenaissance.org/svceo"

                        if(p_rec['terminals'] &&  p_rec['terminals'][0]){
                            let ta =  p_rec['terminals'][0]
                            aird = ta["distance"]
                            airc = ta["terminalCode"]
                            p_rec['airportDistance'] =  `${aird} miles from  ${airc} airport`
                        }
                    let p_item = {}
                    let p_lc = {}
                    p_item = p_rec
                    p_lc =lowercaseKeys(p_item)
                    prices.push(p_lc)
                   
                });
                prices.forEach(p => {
                    let k =p.spacekey
                    prices_map[k] = p
                });
                console.log('sv**SPET9 MONDAY **************** Prices_map START')
                console.log(prices_map)
                console.log('sv**SPET9 MONDAY **************** Prices_map END')
                if(r.data.length>0){
                    const ar = r.data
                    const comData = { my_data: []}
                    let item , ob, upperOb
                    if( r2.data && r2.data.images[0]){
                        comData.my_images = r2.data.images[0]
                    }
                    //get path and concat them wil base url
                  
                    ar.forEach(a_rec => {
                        let myh = a_rec['hotel']
                        /*
                        let mys = a_rec['SPACEKEY']
                        let p =mys.indexOf('@')
                        let mytail = mys.substr(p, mys.length) 
                        
                        let myhead = myh['code']
                        let ckey =myhead + mytail
                        a_rec['SPACEKEY'] = ckey
                        if(a_rec['SPACE_KEY'] ){
                            a_rec['SPACE_KEY'] = ckey
                            a_rec['SOJOURNCODE'] = ckey
                            a_rec['SPACE_INV_ID']= ckey
                            a_rec['ABODE_SPACE_ID'] = ckey
                            a_rec['ABODESPACEID'] = ckey
                            
                        }
                        */
                        a_rec['ranking'] = myh['ranking'] ?myh['ranking'] : "NA"
                        a_rec['web'] = myh['web'] ?myh['web'] : "NA"

                        a_rec['SOJOURN_NAME']= myh['sojourn_name']
                        a_rec["COUNTRY_NAME"]= myh['countryCode']
                        let address_s = a_rec["ADDRESS_LINE1"]
                        const {address} = myh
                        let anum_s = address.number ?address.number : ''
                       
                        if(myh['address']){
                            address_s =  anum_s + " "+address.street
                        }
                        a_rec["ADDRESS_LINE1"] = address_s
                        item = {}
                        let hbd_images  = a_rec.hotel.images
                        let imgs = []
                        //hbd_images  = hbd_images? hbd_images : r2.data.images
                        if(hbd_images && (hbd_images.length > 0) ){
                            hbd_images.forEach(im =>{
                                let sim =  HBD_URL +  im.path 
                                imgs.push(sim)
                               })
                        }else{
                            imgs = r2.data.images
                        }
                       
                        if(imgs.length > 0){
                            comData.my_images = imgs
                        }

                        upperOb = a_rec
                        ob =lowercaseKeys(upperOb)
                        
                        let k_sv = ob['spacekey']
                        a_price = prices_map[k_sv]
                        let reviews_ob = a_price["reviews"]
                        let review_ob = reviews_ob[0]
                       //num_reviews
                        let rating = (review_ob['rate']? review_ob['rate'] : 0 )
                        let reviewCount = (review_ob[ "reviewCount"]? review_ob[ "reviewCount"] : 0 )
                        ob['num_reviews'] = reviewCount
                        //let rating = (ob['svr_vep_rating']? ob['svr_vep_rating'] : 0 )
                        let sv_rating = 'Excellent'
                       if(rating == 0){
                        sv_rating = 'Excellent'
    
                       }else if(rating == 1){
    
                        sv_rating = 'Poor'
                    }else if(rating == 2){
                        sv_rating = 'Fair'
                    }else if(rating == 3){
    
                        sv_rating = 'Recommend'
                    }else if(rating == 4){
                        sv_rating = 'Favorite'
                    }else if(rating == 5){
                        sv_rating = 'Excellent'
                    }else {
    
                        sv_rating = 'Excellent'
                       }
                    ob['sv_rating'] = sv_rating
                    ob['sv_availability_of_rooms'] = 8
                    ob['imgs'] = imgs
                    
                    if(a_price){

                        ob = _.merge(ob, a_price)
                    }
                         
                       /*
                        item['sojourncode']= ob['sojourncode']
                        item['vernacularcode']= ob['vernacularcode']
                        item['sojourn_name']= ob['sojourn_name']
                         comData.my_data.push(item)
                        */
                       
    
                        comData.my_data.push(ob)
                        console.log('sv**OCT16 esqueryText partof sv_esquery_data*********', sv_esquery_data)
                        comData.sv_esquery_data =  sv_esquery_data  
                    });
                   
                   
                    dispatch(getEsSearchMultiplceCallsSuccess(comData))
                }
                else {
                    const comData = { items: []}
                    comData.sv_esquery_data = {
                        my_esqueryText: "mexco",
                        STARTDATE:"2023-10-24",
                        ENDDATE: "2023-11-27" , 
                        time_zone: "+01:00"
                
                      }
                    dispatch(getEsSearchSuccess(comData))
                }
                  
                   
                }
            )
        ).catch(
            e=>{dispatch(getEsSearchError(e))}
           
        )
       
    }
}

/*sjjun18 start*/
export function sojAndImagesSojournFacet(sojPostRqFromPage, sv_esquery_data){
    
    console.log("svoct17 sojAndImagesSojournFacet ******sv_esquery_data", sv_esquery_data)
    return dispatch => {
        dispatch(getEsSearchBegin())
       //svuilaFacetView
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuilaFacetViewCanQuery`
       // const urlSoj = `${SV_SOJ_SVDJMOCK_ADDRESS}/trip/absvfacetab/`
       //sjFacetOnlyDyna
       //http://localhost:8086/sojournpoint/svsojournCanQueryFinalDynaPaginate
       let urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/svsojournCanQueryFinalDynaPaginate   `
   

          let sojPostRq = {
            "dates": {
                "STARTDATE_ITN_TZAWARE_EST": "2025-11-25",
                "ENDDATE_ITN_TZAWARE_EST": "2025-11-27",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "+01:00",
                "OP": "range"
            },
            "facets": {
               "EN_AMENITY_NAME_LVL.keyword": ["Health Club", "WiFi Available"]
            },
            "loc": "mexico"
    
        }
        const HBD_URL = 'http://photos.hotelbeds.com/giata/'
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        let svpricegateway = ''
        
     /*
     "pagenumber": 1,
    "my_scr_id": ""
"rooms.roomType"
     */
    //delete roomTypes not working
        if(sojPostRqFromPage){
              
            /*sjjan9 start */
            let {facets} = sojPostRqFromPage
            
            if(facets.svpricegateway && (facets.svpricegateway.length > 3)){
                svpricegateway = facets.svpricegateway

            }
            /*svjan15*/
            if(svpricegateway == PRICEGATEWAY_AMD){
              //  urlSoj =  `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/svsojournCanQueryFinalDynaPaginateAMDMARRIOTT`
                urlSoj =  `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/svsojournCanQueryFinalDynaPaginateAMDMARRIOTTGEO`
              
                if(facets.svchaincode && (facets.svchaincode.length > 3)){
                   
    
                }else{
                    facets.svchaincode = 'SVALL'
                    
                   
                }
                if(facets.accommodationTypeCode && (facets.accommodationTypeCode.length > 1)){
                   
    
                }else{
                    facets.accommodationTypeCode = 'H'
                    
                   
                }
                
// "accommodationTypeCode": "H",
            }else if(svpricegateway == PRICEGATEWAY_SOJOURN){
                urlSoj =  `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/svsojournCanQueryFinalDynaPaginate`
                delete sojPostRqFromPage.esqueryIata
                if(facets.svchaincode && (facets.svchaincode.length > 3)){
                   
    
                }else{
                    facets.svchaincode = 'SVALL'
                    
                   
                }
            }else{
                urlSoj =  `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/svsojournCanQueryFinalDynaPaginate`
                delete sojPostRqFromPage.esqueryIata
                if(facets.svchaincode && (facets.svchaincode.length > 3)){
                   
    
                }else{
                    facets.svchaincode = 'SVALL'
                    
                   
                }
            }
            /*sjjan9 end */
            /*remove svpricegateway as the service doenot has this and will cay=use es to fail */
            if(facets.svpricegateway && (facets.svpricegateway.length > 3)){
                   
                delete facets.svpricegateway

            }

            sojPostRq = sojPostRqFromPage
            sojPostRq[ "pagenumber"] = 1
            sojPostRq[  "my_scr_id"] = ""
            sojPostRq[  "useCity"] = false
           delete sojPostRq['facets']['EN_ACTIVITY_NAME_LVL.keyword']
          // delete sojPostRq['facets']['rooms.roomType']
           let {SVR_VEP_RATING} =sojPostRq['facets']
           
           let categoryCodes = []

           SVR_VEP_RATING.forEach(v=>{
            categoryCodes.push(v + 'LUX')
            categoryCodes.push(v + 'EST')
           })
          //  "4LUX",
          
       /*
          let categoryCode =  categoryCodes[0] ?categoryCodes[0]: "4LUX"
          sojPostRq['facets']['categoryCode'] = categoryCode
          */
          sojPostRq['facets']['categoryCode'] = categoryCodes
          delete sojPostRq['facets']['SVR_VEP_RATING']
          // delete sojPostRq['facets']['EN_ACTIVITY_NAME_LVL.keyword']
         
        }

        
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers})
        ])
        .then(
            axios.spread((rFobAx,r2)=>{
                let rFob = rFobAx.data
                let r = {data:{}}
                r.data = rFob.svo
                let p = {data:{}}
                p.data  = rFob.dbo
                let prices = []
                let prices_idx = []
                let a_price = null;
                let prices_map = {}
               
                if(p.data.length>0){
                    prices_idx = p.data
                }
                let aird = null
                let airc = null
                prices_idx.forEach(p_rec => {
                    let myh = p_rec['hotel']
                    //change this code as SPACEKEY is number
                    /*
                        let mys = p_rec['SPACEKEY']
                        let p =mys.indexOf('@')
                        let mytail = mys.substr(p, mys.length) 
                        
                        let myhead = myh['code']
                        let ckey =myhead + mytail
                         p_rec['SPACEKEY'] = ckey
                        p_rec['ABODE_SPACE_ID'] = myhead
                        p_rec['SOJOURN_NAME']= myh['sojourn_name']
                        if(p_rec['SPACE_KEY'] ){
                            p_rec['SPACE_KEY'] = ckey
                        }
                    */
                       
                        p_rec['ranking'] = myh['ranking'] ?myh['ranking'] : "NA"
                        p_rec['web'] = myh['web'] ?myh['web'] : "http://svrenaissance.org/svceo"

                        if(p_rec['terminals'] &&  p_rec['terminals'][0]){
                            let ta =  p_rec['terminals'][0]
                            aird = ta["distance"]
                            airc = ta["terminalCode"]
                            p_rec['airportDistance'] =  `${aird} miles from  ${airc} airport`
                        }
                    let p_item = {}
                    let p_lc = {}
                    p_item = p_rec
                    p_lc =lowercaseKeys(p_item)
                    prices.push(p_lc)
                   
                });
                prices.forEach(p => {
                    let k =p.spacekey
                    prices_map[k] = p
                });
                console.log('sv**SPET9 MONDAY **************** Prices_map START')
                console.log(prices_map)
                console.log('sv**SPET9 MONDAY **************** Prices_map END')
                if(r.data.length>0){
                    const ar = r.data
                    const comData = { my_data: []}
                    let item , ob, upperOb
                    if( r2.data && r2.data.images[0]){
                        comData.my_images = r2.data.images[0]
                    }
                    //get path and concat them wil base url
                  
                    ar.forEach(a_rec => {
                        let myh = a_rec['hotel']
                        /*
                        let mys = a_rec['SPACEKEY']
                        let p =mys.indexOf('@')
                        let mytail = mys.substr(p, mys.length) 
                        
                        let myhead = myh['code']
                        let ckey =myhead + mytail
                        a_rec['SPACEKEY'] = ckey
                        if(a_rec['SPACE_KEY'] ){
                            a_rec['SPACE_KEY'] = ckey
                            a_rec['SOJOURNCODE'] = ckey
                            a_rec['SPACE_INV_ID']= ckey
                            a_rec['ABODE_SPACE_ID'] = ckey
                            a_rec['ABODESPACEID'] = ckey
                            
                        }
                        */
                        a_rec['ranking'] = myh['ranking'] ?myh['ranking'] : "NA"
                        a_rec['web'] = myh['web'] ?myh['web'] : "NA"

                        a_rec['SOJOURN_NAME']= myh['sojourn_name']
                        a_rec["COUNTRY_NAME"]= myh['countryCode']
                        let address_s = a_rec["ADDRESS_LINE1"]
                        const {address} = myh
                        let anum_s = address.number ?address.number : ''
                       
                        if(myh['address']){
                            address_s =  anum_s + " "+address.street
                        }
                        a_rec["ADDRESS_LINE1"] = address_s
                        item = {}
                        let hbd_images  = a_rec.hotel.images
                        let imgs = []
                        //hbd_images  = hbd_images? hbd_images : r2.data.images
                        if(hbd_images && (hbd_images.length > 0) ){
                            hbd_images.forEach(im =>{
                                let sim =  HBD_URL +  im.path 
                                imgs.push(sim)
                               })
                        }else{
                            imgs = r2.data.images
                        }
                       
                        if(imgs.length > 0){
                            comData.my_images = imgs
                        }

                        upperOb = a_rec
                        ob =lowercaseKeys(upperOb)
                        
                        let k_sv = ob['spacekey']
                        a_price = prices_map[k_sv]
                        let reviews_ob = a_price["reviews"]
                        let review_ob = reviews_ob[0]
                       //num_reviews
                        let rating = (review_ob['rate']? review_ob['rate'] : 0 )
                        let reviewCount = (review_ob[ "reviewCount"]? review_ob[ "reviewCount"] : 0 )
                        ob['num_reviews'] = reviewCount
                        //let rating = (ob['svr_vep_rating']? ob['svr_vep_rating'] : 0 )
                        let sv_rating = 'Excellent'
                       if(rating == 0){
                        sv_rating = 'Excellent'
    
                       }else if(rating == 1){
    
                        sv_rating = 'Poor'
                    }else if(rating == 2){
                        sv_rating = 'Fair'
                    }else if(rating == 3){
    
                        sv_rating = 'Recommend'
                    }else if(rating == 4){
                        sv_rating = 'Favorite'
                    }else if(rating == 5){
                        sv_rating = 'Excellent'
                    }else {
    
                        sv_rating = 'Excellent'
                       }
                    ob['sv_rating'] = sv_rating
                    ob['sv_availability_of_rooms'] = 8
                    ob['imgs'] = imgs
                    
                    if(a_price){

                        ob = _.merge(ob, a_price)
                    }
                         
                       /*
                        item['sojourncode']= ob['sojourncode']
                        item['vernacularcode']= ob['vernacularcode']
                        item['sojourn_name']= ob['sojourn_name']
                         comData.my_data.push(item)
                        */
                       
    
                        comData.my_data.push(ob)
                        console.log('sv**OCT16 esqueryText partof sv_esquery_data*********', sv_esquery_data)
                        comData.sv_esquery_data =  sv_esquery_data  
                    });
                    console.log('SJ******JUN20**** GOT FACET DATA S')
                    
                   
                    dispatch(getEsSearchMultiplceCallsSuccess(comData))
                }
                else {

                    console.log('SJ******JUN20**** EMPTY FACET DATA SHHOW ERROR MESSAGE REFINE')
                    const comData = { items: []}
                    comData.sv_esquery_data = {
                        my_esqueryText: "mexco",
                        STARTDATE:"2025-10-24",
                        ENDDATE: "2025-11-27" , 
                        time_zone: "+01:00"
                
                      }
                      if(sv_esquery_data){
                        comData.sv_esquery_data = sv_esquery_data
                      }
                      /*sjjun19 start
                       dispatch(getEsSearchSuccess(comData))

                      */
                    dispatch(getEsSearchServerError(comData))
                }
                  
                   
                }
            )
        ).catch(
            e=>{dispatch(getEsSearchError(e))}
           
        )
       
    }
}


export const saveRoomSuccess = (rdata) => dispatch => {
    let data  = {
        sv_room_data : rdata
    }
    dispatch({
        type: "room-success",
        payload: data
    })
}
